import { AWSkinnyUserPreference } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { OrderedPageGroups, ReportOverride } from './../AWPortfolioManagement/index';
import { userPreferenceApi } from './Base';

//temp types till types are available from microservice

export type UserPrefReportOverride = ReportOverride & Pick<AWSkinnyUserPreference, 'userPreferenceMetadata'>;

export type UserPrefReportOverrideResponse = {
  reportOverrides: Array<{
    [key in keyof ReportOverride as key extends 'pageGroups' ? 'reportPageGroups' : key]: ReportOverride[key] extends
      | OrderedPageGroups
      | undefined
      ?
          | Array<{
              [Okey in keyof OrderedPageGroups[number] as Okey extends 'pages'
                ? 'reportPages'
                : Okey]: OrderedPageGroups[number][Okey];
            }>
          | undefined
      : ReportOverride[key];
  }>;
} & Pick<AWSkinnyUserPreference, 'userPreferenceMetadata'>;

export async function getReportOverrides(pkg: string) {
  const path = '/v1/report-overrides';
  const response = await userPreferenceApi.get<AGraphWrappedType<UserPrefReportOverrideResponse[], 'reportOverrides'>>(
    path,
    { params: { pkg } }
  );
  return unwrapAGraphResponse(response, 'reportOverrides');
}

export async function postReportOverride(reportOverride: ReportOverride, pkg: string) {
  const path = '/v1/report-overrides';
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'id'>>(
    path,
    {
      reportOverrides: [
        {
          templateSetName: reportOverride.templateSetName,
          reportPageGroups: reportOverride.pageGroups?.map((pageGroup) => ({
            groupName: pageGroup.groupName,
            reportPages: pageGroup.pages.filter((page) => !page.attachments),
          })),
        },
      ],
    },
    { params: { pkg } }
  );
  return unwrapAGraphResponse(response, 'id');
}

export async function putReportOverride(reportOverride: ReportOverride, id: string, pkg: string) {
  const path = `/v1/report-overrides/${id}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'id'>>(
    path,
    {
      reportOverrides: [
        {
          templateSetName: reportOverride.templateSetName,
          reportPageGroups: reportOverride.pageGroups?.map((pageGroup) => ({
            groupName: pageGroup.groupName,
            reportPages: pageGroup.pages.filter((page) => !page.attachments),
          })),
        },
      ],
    },
    { params: { pkg } }
  );
  return unwrapAGraphResponse(response, 'id');
}
